import {Component, OnInit, OnDestroy} from '@angular/core';
import {Constants} from 'config/constants';
import {Router, NavigationEnd, Event} from '@angular/router';
import {Subscription} from 'rxjs/Subscription';

@Component({
    selector: 'tpc-events-calculator',
    templateUrl: './events-calculator.component.html',
    styleUrls: ['./events-calculator.component.css']
})
export class EventsCalculatorComponent implements OnInit, OnDestroy {
    private routerSubscription: Subscription;

    public isGatePage = false;
    public calculatorName: string = Constants.calculators.events;
    public menuItems: Array<any> = [
        {
            name: 'travel',
            title: 'Travel',
            url: '/events/travel',
            checked: false
        },
        {
            name: 'commute',
            title: 'Commute',
            url: '/events/commute',
            checked: false
        },
        {
            name: 'venue',
            title: 'Venue',
            url: '/events/venue',
            checked: false
        },
        {
            name: 'water',
            title: 'Water',
            url: '/events/water',
            checked: false
        },
        {
            name: 'meals',
            title: 'Meals',
            url: '/events/meals',
            checked: false
        },
    ];

    constructor(private router: Router) {
        this.routerSubscription = router.events.subscribe((event: Event) => {
            if (event instanceof NavigationEnd) {
                this.isGatePage = event.urlAfterRedirects.includes('/gate/default');
            }
        });
    }

    ngOnInit() {
    }

    ngOnDestroy () {
        if (this.routerSubscription) {
            this.routerSubscription.unsubscribe();
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/components/calculator/calculator-item/events-calculator/events-calculator.component.ts